import { createContext, useContext, type PropsWithChildren } from "react";
import type { MembershipApi } from "../data/MembershipApi";

const Context = createContext<MembershipApi | null>(null);

export function MembershipProvider({ api, children }: PropsWithChildren<{ api: MembershipApi }>) {
  return <Context.Provider value={api}>{children}</Context.Provider>;
}

export function useMembershipApi() {
  const value = useContext(Context);
  if (!value) throw new Error("useMembershipApi must be used within MembershipProvider");
  return value;
}
